<template>

</template>

<script>
    export default {
        name: "Main.vue"
    }
</script>
